export default (() => {
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.js-cart-badge').forEach((el) => {
      let success_message = el.dataset.successMessage || '成功加入購物車'
      let value_attr = el.dataset.valueAttr || 'item_line_items_size'
      document.addEventListener('odims:cart:line_item:added', (event) => {
        if (event.detail.line_item_params.line_item_type != 'discount') {
          if (event.detail.cart) {
            let badge_count = event.detail.cart[value_attr]
            document.querySelectorAll('.js-cart-badge').forEach((el) => {
              el.innerHTML = badge_count
            })
            window.$odin.flash_msg(success_message, 'success')
          } else {
            window.$odin.flash_msg(event.detail.error, 'error')
          }
        }
      })
      document.addEventListener('odims:cart:current', (event) => {
        let badge_count = event.detail.cart[value_attr]
        document.querySelectorAll('.js-cart-badge').forEach((el) => {
          el.innerHTML = badge_count
        })
      })
    })
  })
})()
